
export const ETS_GROUP_IDS = [
  '22cc8b45-aa77-49aa-8fb2-c39bb884fa13',
  '504daea8-fd6b-4b06-8e5f-dc1a90558ede',
] as const

export const GOODS_GROUP_IDS = [
  '841cea5e-1c0b-4f92-a94d-d6c83ad43e5e',
  'bf3e2e90-8c4a-4fca-b9f2-2d4a1d16ab55',
] as const

// Groups where the sold-product catalogue books downstream emissions from stage figures:
// Cat 11 Use of Sold Products (units sold x stage B) and Cat 12 End of Life Treatment
// (units sold x stage C). Mirrors the backend's STAGE_FIELD_BY_DOWNSTREAM_GROUP_ID.
export const SOLD_PRODUCT_GROUP_IDS = [
  '5990f0b3-9b64-4dbc-bee4-2135789bfda2',
  '6a5a85d9-b5b6-4230-8a12-90b7d0cfc0a8',
] as const

// Stage-specific wording per downstream group, so each page describes the figure it books.
export interface ISoldProductStageConfig {
  stageField: 'stageB' | 'stageC'
  perUnitLabel: string
  perUnitShort: string
  previewLabel: string
  bookingDescription: string
  missingFigureText: string
}

export const SOLD_PRODUCT_STAGE_BY_GROUP_ID: Record<string, ISoldProductStageConfig> = {
  '5990f0b3-9b64-4dbc-bee4-2135789bfda2': {
    stageField: 'stageB',
    perUnitLabel: 'Use-stage kg CO2e per unit (B)',
    perUnitShort: 'use phase / unit',
    previewLabel: 'Estimated lifetime use-phase total',
    bookingDescription: 'the B use-stage figure recorded on the product (its expected lifetime use-phase emissions per unit)',
    missingFigureText: 'B use-stage',
  },
  '6a5a85d9-b5b6-4230-8a12-90b7d0cfc0a8': {
    stageField: 'stageC',
    perUnitLabel: 'End-of-life kg CO2e per unit (C)',
    perUnitShort: 'end of life / unit',
    previewLabel: 'Estimated end-of-life total',
    bookingDescription: 'the C end-of-life figure recorded on the product (its expected treatment and disposal emissions per unit)',
    missingFigureText: 'C end-of-life',
  },
}

// Scope 3 Leased Assets (upstream / downstream). Floor-area utility estimates book here.
export const LEASED_ASSET_GROUP_IDS = [
  '6a94ae1a-310f-4104-b5b8-4e578159c422',
  '1c2a4c95-f4c5-4565-854c-f5129b648520',
] as const

// Scope 1's groups, in the order the app lists them. An archived report period's Scope 1 breakdown
// is keyed by these ids. Mirrors the backend's SCOPE_ONE_GROUPS (lib/constants/groups.constants.js).
export const SCOPE_ONE_GROUPS: { id: string, label: string }[] = [
  { id: '22cc8b45-aa77-49aa-8fb2-c39bb884fa13', label: 'Company Facilities' },
  { id: '504daea8-fd6b-4b06-8e5f-dc1a90558ede', label: 'Company Vehicles' },
]
